import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchTodayRecommendations } from "../api";
import { useAuth } from "./AuthContext";

const RecommendationsContext = createContext(null);

export function RecommendationsProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isAuthenticated, user } = useAuth();

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const d = await fetchTodayRecommendations();
      setData(d);
      setError(null);
    } catch (e) {
      setError("No pudimos cargar las recomendaciones.");
    } finally {
      setLoading(false);
    }
  }, []);

  // Re-fetch whenever the auth state changes so the VIP fields unmask/mask
  useEffect(() => {
    refresh();
  }, [refresh, isAuthenticated, user?.id]);

  return (
    <RecommendationsContext.Provider value={{ data, loading, error, refresh }}>
      {children}
    </RecommendationsContext.Provider>
  );
}

export const useRecommendations = () => {
  const ctx = useContext(RecommendationsContext);
  if (!ctx) throw new Error("useRecommendations must be used within RecommendationsProvider");
  return ctx;
};
